import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { getSubTags, hasTag, loadTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../edit-tags/edit-tags.component';
import { Business } from '../../business/models/business.model';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var RentalCarsComponent = /** @class */ (function () {
    function RentalCarsComponent(_editCommunicationsDialog, _toggleService, snackBar, _editRentalCarsCheckboxDialog, _businessManagerService) {
        this._editCommunicationsDialog = _editCommunicationsDialog;
        this._toggleService = _toggleService;
        this.snackBar = snackBar;
        this._editRentalCarsCheckboxDialog = _editRentalCarsCheckboxDialog;
        this._businessManagerService = _businessManagerService;
        this.hasTag = hasTag;
        this.editModeSet = false;
        this._rentalCarTags = [];
        this.isRegionalManager = false;
    }
    RentalCarsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this._rentalCarTags = loadTags(this.business.tags, 'Rental Car::', '', '');
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 1:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_c.sent());
                        _c.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RentalCarsComponent.prototype, "hasContent", {
        get: function () {
            return getSubTags(this.business.tags, 'Rental Car::').length > 0;
        },
        enumerable: true,
        configurable: true
    });
    // For Now 10/30/18, Enterprise is the only rental car company that we show the logo for,
    // we will eventually change that and all logos to be displayed
    // get nonEnterpriseRentalCars(): String[] {
    //   const result: String[] = [];
    //   for (const currentTag of this.business.tags) {
    //     if (currentTag.tagName.startsWith('Rental Car::') &&
    //       !currentTag.tagName.includes('Enterprise')) {
    //       result.push(currentTag.displayName);
    //     }
    //   }
    //   return result.sort();
    // }
    RentalCarsComponent.prototype.openEditRentalCarsDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editRentalCarsCheckboxDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                _this._rentalCarTags = loadTags(_this.business.tags, 'Rental Car::', '', '');
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return RentalCarsComponent;
}());
export { RentalCarsComponent };
